$(document).ready(function(){

    function toggleAccordion(_this) {
        var answer = $(_this).parent().find('.accordion-hidden').first();
        var height = answer.data('height');

        $(_this).parent().toggleClass('accordion-open');

        if( answer.hasClass('d-none') ) {
            answer.removeClass('d-none');
            answer.animate({'height' : height}, 300);
        } else {
            answer.animate({'height' : 0}, 300);

            setTimeout(function(){
                answer.addClass('d-none');
            }, 301);
        }
    }

    $('.accordion-hidden').each(function(){
        var answerHeight = $(this).outerHeight();
        $(this).data({'height' : answerHeight});
        $(this).addClass('d-none');
        $(this).css('height', 0);

        var _this = $(this);

        $(this).click(function(){
            toggleAccordion(this);
        })
    });

    $('.accordion-header').click(function(){
        toggleAccordion(this);
    })
})
